/** Same Web client ID the mobile app uses for Google Sign-In. */
export const GOOGLE_WEB_CLIENT_ID =
  '957259534452-d6268ro7q61q1hom431h3eltg6egp520.apps.googleusercontent.com';
